import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Token } from './../base-models/token';
import { Observable, BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserRightsService } from './user-rights.service';
import { DefgIniService } from './defg-ini.service';
// import { ConfirmationDialogButtons } from '../../public_api';
import { ConfirmationDialogButtons } from '../base-components/confirmation-dialog/confirmation-dialog-buttons';
// import { ModalService } from '../../public_api';
import { ModalService } from '../base-services/modal.service';
import { CryptoService } from './crypto.service';
import { BaseDataService } from './base-data.service';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private configService: ConfigService,
    private userRightsService: UserRightsService,
    private defgIniService: DefgIniService,
    protected modalService: ModalService,
    private baseDataService: BaseDataService
  ) { }

  private tokenKey: string = 'yt-app-token';

  private _isAuthenticationSubject: BehaviorSubject<boolean> = new BehaviorSubject(CryptoService.Decrypt(sessionStorage.getItem(this.tokenKey)) != null);
  IsAuthenticated: Observable<boolean> = this._isAuthenticationSubject.asObservable();

  Login(username: string, password: string){
    var logindata = 'grant_type=password&username=' + encodeURI(username) + '&password=' + encodeURI(password);
    let __this = this;

    // 🚀 Učitaj URL cenovnika odmah pre nego što se korisnik prijavi
    this.configService.GetPricelistUrlAsync().subscribe(url => {
      //console.log('Cenovnik URL pre prijave:', url);
      __this.configService.SetPricelistUrl(url);
    });

    return this.configService.GetApiUrlAsync()
      .pipe(switchMap(config => {
    return this.httpClient.post(config + 'Token', logindata, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
      .pipe(map((data: any) => {
        let token: Token = (new Token()).Deserialize(data);
        __this.setToken(token);
      }))
    }))
  }

  Logout(){
    this.removeToken();
    this.configService.SetSelectedOrgJed(null);
    this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url } });
  }

private setToken(token: Token) {
  const encryptedToken = CryptoService.Encrypt(token);
  sessionStorage.setItem(this.tokenKey, encryptedToken);
  this._isAuthenticationSubject.next(true);

  this.configService.SetSelectedUser({
    Username: token.Username,
    UserID: token.UserID,
    RoleName: token.RoleName
  });

  this.configService.GetApiUrlAsync()
    .pipe(switchMap(api => this.httpClient.get<number>(api + 'api/user/getcurrentuserid')))
    .subscribe((id) => {
      this.configService.SetSelectedUser({
        Username: token.Username,
        UserID: String(id),
        RoleName: token.RoleName
      });
    });
}


  private removeToken(){
    sessionStorage.removeItem(this.tokenKey);
    this._isAuthenticationSubject.next(false);
    sessionStorage.removeItem('sel-user');
    sessionStorage.removeItem('sel-org-jed');
  }

  GetAccessToken(): string{
    let encryptedToken = CryptoService.Decrypt(sessionStorage.getItem(this.tokenKey));
    if (encryptedToken != null)
      return encryptedToken.AccessToken;
    else return '';
  }

  //IsAuthenticated(): boolean {
    //return localStorage.getItem(this.tokenKey) != null;
  //}

  ChangeOrgJed(orgJed){
    let __this = this;
    return this.configService.GetApiUrlAsync()
      .pipe(switchMap(config => {
        return this.httpClient.post(config + 'api/user/changeOrgJed', orgJed)
          .pipe(map((data: any) => {
            //let token: Token = (new Token()).Deserialize(data);
            //__this.setToken(token);
            this.updateAccessToken(data);
            this.configService.SetSelectedOrgJed(orgJed);
            this.userRightsService.LoadUserRights();
            this.defgIniService.LoadDefgIniData()
              .subscribe(() => {});
          })
      )}))
  }

  CheckLicenseExpiration(orgJed){
    let __this = this;
    return this.configService.GetApiUrlAsync()
      .pipe(switchMap(config => {
        return this.httpClient.post(config + 'api/user/checkLicenseExpiration', orgJed)
          .pipe(map((data: number) => {
            if (data>0 && data<5)
            this.modalService.ShowConfirmationDialog("Upozorenje", "Bliži se istek licence, ostalo Vam je još "+data.toString()+" dana!", 'warning', ConfirmationDialogButtons.Ok);
          })
      )}))
  }

  private updateAccessToken(accessToken: string){
    let decryptedToken = CryptoService.Decrypt(sessionStorage.getItem(this.tokenKey))
    decryptedToken.AccessToken = accessToken;
    let encryptedToken = CryptoService.Encrypt(decryptedToken);
    sessionStorage.setItem(this.tokenKey, encryptedToken);
  }

  RefreshToken(){
  }
}
